import SearchFormFieldGroup from 'components/SearchV2/Components/SearchFormField/SearchFormFieldGroup'
import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import Group from 'components/utils/Group'
import LineUserIcon from 'LuxKit/Icons/line/LineUserIcon'
import AssistChip from 'LuxKit/Chips/AssistChip'

interface MappedStateProps {
  businessAccount?: App.BusinessTraveller.CurrentBusinessAccount
}

interface Props {
  className?: string;
}

function BusinessTravellerSelectHotelsDesktopDisabled(props: Props & MappedStateProps) {
  const {
    className,
    businessAccount,
  } = props

  // Plain "Travellers" until the account has loaded, which also makes this the loading placeholder
  const travellerLabel = useMemo(() => {
    const { firstName = '', lastName = '' } = businessAccount?.employee ?? {}
    const travellerName = `${firstName} ${lastName}`.trim()
    return travellerName ? <>Travellers: <b>{travellerName}</b></> : 'Travellers'
  }, [businessAccount?.employee])

  return (
    <SearchFormFieldGroup className={className}>
      <Group direction="horizontal" gap={12} wrap="wrap">
        <AssistChip
          variant="outline"
          size="medium"
          startIcon={<LineUserIcon />}
          disabled
        >
          {travellerLabel}
        </AssistChip>
        <AssistChip
          variant="outline"
          size="medium"
          disabled
        >
          1 room
        </AssistChip>
      </Group>
    </SearchFormFieldGroup>
  )
}

export default connect<MappedStateProps, {}, Props, App.State>((state) => {
  return {
    businessAccount: state.businessTraveller.currentBusinessAccount,
  }
})(BusinessTravellerSelectHotelsDesktopDisabled)
